<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/190725-feature-infant-food-allergy.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">最易被忽略的一種過敏食物</div>
                   <div class="post_info">Posted at 09:00h in 致敏原</div>
                   <p class="post_wrapper">好多家長都話小朋友有食物過敏，情況有幾普遍？大家對幼兒食物過敏的認知有多少？
                       早前香港過敏協會收集了850份問卷，結果發現超過 8 成兩歳或以下的幼兒曾經出現敏感症狀，轉天氣及食物是引起敏感的主要原因。
                       食物敏感方面，雞蛋、海鮮及牛奶是最常見致敏源，當中最易被家長忽略的是牛奶。</p>

                    
                    <div class="post_wrapper_tip">家長對食物敏感認知偏低</div>
                    <div class="post_wrapper_1">
                        香港過敏協會顧問免疫及過敏病科鄔揚源醫生認為，調查結果反映家長對食物過敏的認知不足。「雞蛋成為最常引致幼兒過敏的食物，
                        原因是雞蛋屬於日常生活常用的食材，含有豐富蛋白質，所以家長喜好餵飼幼兒進食雞蛋。然而幼兒免疫系統未發展成熟，會將蛋白質當成有害物質，令身體作出過敏反應。
                        海鮮是第二大致敏食物則與香港人飲食習慣有關，家長開始讓幼兒接觸固體食物時會用魚類或其他海鮮，因肉身較軟且含豐富營養成分。」
                    </div>
                     <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190725-egg-fish.jpg"/>

                    </div>
                     <div class="post_wrapper_1 margin_top">
                         調查顯示，超過 8 成家長聽過牛奶蛋白敏感，但最少人懷疑幼兒有此症狀 (3％)，確診人數卻排行第三。
                         當中3 成 (32.4%) 家長試過避免幼兒飲用牛奶產品，但醫生指這做法有機會令幼兒吸收不夠營養成分，影響身體發育。</div>
                    <div class="post_wrapper_tip">切勿胡亂戒口</div>
                    <div class="post_wrapper_1">
                        若發現幼兒出現過敏症狀如痕癢、紅腫、蕁麻疹、濕疹、腹痛、嘔吐、腹瀉、氣喘、咳嗽、眼睛搔癢等，應盡快徵詢兒科醫生意見，
                        因情況嚴重可以危害生命。對於雞蛋和海鮮敏感，可避免幼兒吃這類食物，亦需注意加工及預先製作的食品是否含有相關食材。</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190725-breast-feeding.jpg"/>
                    </div>
                    <div class="post_wrapper_tip">深度水解蛋白奶粉有助減低過敏反應</div>
                    <div class="post_wrapper_1">
                        至於應對牛奶蛋白敏感，可選擇餵哺母乳。如有需要則可選擇深度水解蛋白的奶粉，可以訓練免疫系統習慣牛奶蛋白。
                        深度水解蛋白奶粉經過特別處理，而添加了LGG 的深度水解蛋白奶粉，有助嬰兒成功適應牛奶蛋白。
                    </div>
                    <div class="post_wrapper_tip">人口密集地、產檢時孕婦應佩戴口罩</div>
                    <div class="post_wrapper_1">
                        醫生再次提醒家長，應認清哪種食物引起過敏，不要胡亂或過度戒口，影響幼兒的營養吸收。
                        </div>
                    
                    <div class="post_wrapper_1">
                        資料來源：<a href="#">Oh!爸媽</a>
                    </div>
               </div>
           </div>
           <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    margin-bottom:25px;
    font-family: 'Microsoft JhengHei',sans-serif !important;
      margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:10px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
                .margin_top{
                    margin-top:35px;
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/gensthree.vue